import { z } from "zod";
import { NotificationFilter } from "../enum.js";

export const notificationListQuerySchema = z
	.object({
		cursor: z.string().optional(),
		limit: z.coerce.number().int().min(1).max(50).default(20),
		filter: z.enum(NotificationFilter).default(NotificationFilter.ALL),
		community_id: z.uuid().optional(),
	})
	.strict();

export type NotificationListQueryPayload = z.infer<typeof notificationListQuerySchema>;
